import React from 'react'
import { Routers } from './routers/Routers'

export const App = () => {
  return (
    <div>
      <Routers /> 
    </div>
  )
}
